import { render, staticRenderFns } from "./NavDropItem.vue?vue&type=template&id=4bf8de43&scoped=true"
import script from "./NavDropItem.vue?vue&type=script&lang=js"
export * from "./NavDropItem.vue?vue&type=script&lang=js"
import style0 from "./NavDropItem.vue?vue&type=style&index=0&id=4bf8de43&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf8de43",
  null
  
)

export default component.exports